export const mockState = {
    website: {
        checkout: false,
        baseUrl: 'https://localhost',
        popOverAutoHeight: false,
        iconsBackground: 'none',
        popoverOpen: false,
        showCollapsedIcon: true,
        popoverFooterAlignment: 'center',
        authFlow: 'default',
        flow: null,
        footerVisibility: true,
        fullscreenModal: {
            component: null,
            isVisible: false,
            options: {}
        },
        internalModal: {
            component: null,
            isVisible: false,
            options: {}
        }
    },
    auth: {
        connected: true,
        access_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Imdob2lzaGdpQG5vZG8uYWciLCJzdWIiOiI0ZjBmN2NlZi00Nzc4LTRlMjAtYTBiYi0zYWMxOTYyNWQ4NTkiLCJhdXRoVHlwZSI6ImN1c3RvbWVyIiwiZXh0cmFJbmZvIjp7Im5hbWUiOiJodmJoanZkIiwibGFzdG5hbWUiOiJ2YmpoZmJ2aiJ9LCJpYXQiOjE2OTI2NDE3MjksImV4cCI6MTcyNDE3NzcyOX0.0BT14WlYHUnXT7rrgh1BMHXCxx1q9T50JZW7vvwgsh0',
        token: 'eyJraWQiOiIya0RibDk4aiIsImFsZyI6IlJTMjU2In0.eyJkYXRhIjp7IlNIQTI1NiI6IntcIm1lbWJlclwiOntcImlkXCI6XCJjNTUwOTYzMi1mZDVjLTRkNGQtOWU5ZS04YzZkMzM4ODhhMjJcIn19In0sImlhdCI6MTY5MjY0MTcyOCwiZXhwIjoxNzI4NjQxNzI4fQ.eERaGEYxBv7K2OB0ZQ2AKm6338e5r354072fLiewyi73QXWmR1FONdPvqhzP5wQI-a0XyOqYjdSCSe7A21WVx3L9RsFT8AJHjEYxli0qP1D1vrzCyh_-VDrCJqPWewMMiPB4XeCXZJfIHNJcGxLFyNm_s-g55ejU2-G-BKMVOHcSKfz1fHC6KddK4QeF1eCz3bs-kDpRWy6ZAy-TaR4M35EmTeN8j2YRxYEhAhKHMHSitb4hW8aOiVlY_RkSlx8xWXTe49Pq1iwxm98UHxR_2Q67sEFUpmUGbT9EDEBDAuk2B_hNQhFFMCq_GOfm_-iJ1SCzprvrOUfM1vaeLKNHeQ',
        account: 'c5b4f686-0c92-43a4-a410-daf1492173f3'
    },
    business: {
        id: '9a135082-d37d-47f3-b663-8eec4256ffc2',
        createdAt: '2023-07-12T18:45:42.812Z',
        updatedAt: '2023-08-17T20:46:09.000Z',
        otherCategory: '',
        name: 'Car Store',
        slug: 'car-store-ushl1spoj',
        address: null,
        addressAdditional: null,
        merchantId: null,
        city: null,
        state: null,
        zip: null,
        country: 'Germany',
        phoneCountryCode: '55',
        phoneCountryIso: 'BR',
        phone: null,
        website: 'https://www.dev-site-2x9527.wix-dev-center-test.org/',
        facebookLink: null,
        instagramLink: null,
        ein: null,
        title: null,
        description: null,
        video: null,
        videoMetadata: null,
        goal: null,
        views: 0,
        coinExchangeRatio: '1.00',
        coinPurchaseRatio: '33.33',
        coinRewardPercentage: '3.00',
        coinPurchaseBonus: '0.00',
        coinGiveFirst: 'false',
        coinGiveFirstAmount: '0.00',
        coinGiveFirstPotLimit: '0.00',
        coinGiveFirstDistributed: '0.00',
        coinAwardDistributed: '0.00',
        refundsLimitDays: 0,
        lat: '53.93',
        lng: '-1.06',
        branchLinks: {
            landingPageLink: 'https://twism-env-dev.app.link/WlmYP3MEnBb',
            storePageLink: 'https://twism-env-dev.app.link/XQzj33MEnBb'
        },
        status: 'active',
        type: 'online',
        timezone: 'Europe/Berlin',
        giftMetaImageUrl: null,
        customerAcquisition: true,
        customerAcquisitionLink: null,
        sellCoins: false,
        seenWhatsNew: true,
        seenInactiveConsumersHover: true,
        showPlatformFeedback: false,
        hasStartGuide: true,
        customerAcquisitionEnabledAt: '2023-07-13T17:58:36.306Z',
        lastActivationActivityAt: '2023-08-16T13:09:13.527Z',
        onlineMerchantSignup: false,
        rewardStatus: 'active',
        inactiveCustomerDays: 30,
        axxessKeyWords: null,
        logo: {
            id: '4eeb58a0-eea0-4f7c-98a8-836157ef0b80',
            createdAt: '2023-07-12T18:44:57.837Z',
            updatedAt: '2023-07-12T18:44:57.837Z',
            filename: 'blue-700',
            mimetype: 'image/png',
            path: 'https://assets.dev.twism.info/dashboard/npo/business',
            publicPath: {
                small: 'https://assets.dev.twism.info/dashboard/npo/business/blue-700-200x200.png',
                large: 'https://assets.dev.twism.info/dashboard/npo/business/blue-700-600x600.png',
                wideSmall: 'https://assets.dev.twism.info/dashboard/npo/business/blue-700-600x250.png',
                wideLarge: 'https://assets.dev.twism.info/dashboard/npo/business/blue-700-1680x700.png',
                original: 'https://assets.dev.twism.info/dashboard/npo/business/coin-placeholder.png'
            },
            size: '314000',
            context: 'image',
            status: 'active'
        },
        coinSetup: {
            id: 'fec10af0-73bd-4864-9ebd-5a6a2dd022ca',
            createdAt: '2023-07-12T18:44:57.860Z',
            updatedAt: '2023-07-12T18:45:45.000Z',
            color: '205be0',
            colorLabel: 'blue-700',
            name: '$fdgsdfhghgd',
            frontUid: '287ee23b-f89a-40f8-91e9-63a3815d9afd',
            status: 'done',
            hasDefaultLogo: true
        },
        rewardsSettings: {
            id: '61157919-2c8c-11ee-a5a0-02c47bc40bcb',
            createdAt: '2023-07-27T14:46:33.000Z',
            updatedAt: '2023-07-27T14:46:33.000Z',
            coinRewardPercentage: '3.00',
            refundsLimitDays: 0,
            status: 'active'
        },
        loyaltyEnabled: true,
        oauthId: '2b5f195f-bde5-435f-bb47-7c0715e284ac',
        location: {
            id: '0b678ff5-ef0b-11eb-9d86-02420acab302',
            createdAt: '2021-07-27T18:47:07.994Z',
            updatedAt: '2021-07-27T18:47:07.994Z',
            name: 'Germany',
            iso3: 'DEU',
            iso2: 'DE',
            phoneCode: '49',
            capital: 'Berlin',
            currency: 'EUR',
            currencySymbol: '€',
            lang: 'en-US',
            enabled: true,
            metadata: {
                availability: {
                    physical: 'Disabled',
                    online: 'Enabled'
                }
            },
            label: 'Euro',
            phoneMask: '(XXXX) XXX-XXXX'
        }
    },
    customer: {
        id: '4f0f7cef-4778-4e20-a0bb-3ac19625d859',
        name: 'hvbhjvd',
        lastname: 'vbjhfbvj',
        country: null,
        phoneCountryCode: null,
        phone: null,
        birthday: null,
        mail: 'ghoishgi@nodo.ag',
        totalRewards: 0,
        totalSpent: 0,
        totalVisits: 0,
        lastSeen: '2023-08-21T20:03:00.440Z',
        isMailVerified: false,
        businesses: [],
        isSoftUser: false,
        hasFirstName: true,
        hasLastname: true,
        timezone: null,
        hasRedeemedFirstCoin: false,
        invitationUrl: 'https://twism-env-dev.app.link/YqvgOMnlbCb',
        wallet: {
            id: '18676fb2-879d-429c-b03e-bf7dd2074f0d',
            updatedAt: '2023-08-11T17:14:25.044Z',
            money: '0.30',
            coins: '0.30',
            pendingCoins: '0.00',
            status: 'active',
            pendingMoney: '0.00'
        }
    },
    settings: {
        position: 'bottomRight',
        desktopBottomSpacing: 30,
        desktopSideSpacing: 30,
        mobileBottomSpacing: 30,
        mobileSideSpacing: 30,
        enabled: true,
        color: 'yellow',
        desktopWelcome: true,
        mobileWelcome: true,
        widgetStyleIcon: 'coin',
        welcomeEnable: true,
        welcomeTitle: 'Hey there 👋',
        welcomeDescription: "You'll be rewarded with your loyalty Coins after checkout!",
        widgetStyleText: ''
    },
    checkout: {},
    freeCoinsCampaign: {
        alreadyRedeemed: false,
        id: '3eea1db7-5b06-4133-b5e5-807c9dfd5c13',
        createdAt: '2023-07-12T18:45:42.812Z',
        updatedAt: '2023-08-17T20:46:09.000Z',
        coinsReward: '4.00',
        customerLimit: null,
        redeemCounter: 1,
        status: 'active',
        dateLimit: null,
        limitType: 'no-limit',
        allowRepeatingCustomers: 0,
        businessId: '9a135082-d37d-47f3-b663-8eec4256ffc2',
        scheduledCustomerLimit: null,
        visibilityType: 'nationwide',
        name: 'Car Store',
        address: null,
        city: null,
        state: null,
        zip: null,
        website: 'https://www.dev-site-2x9527.wix-dev-center-test.org/',
        addressAdditional: null,
        country: 'Germany',
        phoneCountryCode: '55',
        phone: null,
        categoryId: 'ca7cb6c1-f26f-11e9-ab61-02420aca1102',
        otherCategory: '',
        logoId: '4eeb58a0-eea0-4f7c-98a8-836157ef0b80',
        coinGiveFirst: 'false',
        coinGiveFirstAmount: '0.00',
        coinGiveFirstPotLimit: '0.00',
        coinGiveFirstDistributed: '0.00',
        coinPurchaseRatio: '33.33',
        coinExchangeRatio: '1.00',
        lat: '53.93',
        lng: '-1.06',
        coinPurchaseBonus: '0.00',
        coinAwardDistributed: '0.00',
        type: 'online',
        ein: null,
        title: null,
        description: null,
        video: null,
        goal: null,
        slug: 'car-store-ushl1spoj',
        views: 0,
        stripeConnectId: '54879a16-fa24-4673-8363-0512f16c90c8',
        videoMetadata: null,
        coverImageId: null,
        merchantId: null,
        branchLinks: '{"landingPageLink":"https://twism-env-dev.app.link/WlmYP3MEnBb","storePageLink":"https://twism-env-dev.app.link/XQzj33MEnBb"}',
        refundsLimitDays: 0,
        countryId: '0b678ff5-ef0b-11eb-9d86-02420acab302',
        phoneCountryIso: 'BR',
        giftMetaImageUrl: null,
        coinRewardPercentage: '3.00',
        customerAcquisition: 1,
        customerAcquisitionLink: null,
        sellCoins: 0,
        customerAcquisitionEnabledAt: '2023-07-13T17:58:36.306Z',
        lastActivationActivityAt: '2023-08-16T13:09:13.527Z',
        rewardStatus: 'active',
        seenWhatsNew: 1,
        hasStartGuide: 1,
        timezone: 'Europe/Berlin',
        showPlatformFeedback: 0,
        inactiveCustomerDays: 30,
        seenInactiveConsumersHover: 1,
        facebookLink: null,
        instagramLink: null,
        onlineMerchantSignup: 0,
        axxessKeyWords: null,
        searchName: 'CarStore',
        firstName: 'Car',
        newRedeems: null,
        oldRedeems: null
    },
    referralProgram: {
        id: '5a561f15-3695-452c-a63e-f1e6addac19e',
        createdAt: '2023-07-13T13:07:52.337Z',
        updatedAt: '2023-07-13T13:07:52.337Z',
        referringDiscount: '4.0000',
        referringDiscountType: 'coins',
        referredDiscount: '2.0000',
        referredDiscountType: 'percentage',
        referringMinimumValue: null,
        referredMinimumValue: null,
        isActive: true,
        referredPrefix: 'R',
        referringPrefix: 'R',
        referredMetaImage: 'https://twism-testing.imgix.net/images/referral/5a561f15-3695-452c-a63e-f1e6addac19e?rect=0%2C0%2C600%2C400&s=27e5ef52f2c6fc12106f40bee82812ea'
    },
    referralLink: {
        id: '5ce3faaa-d606-4707-81f3-ab4f53655ecd',
        createdAt: '2023-08-11T17:14:26.734Z',
        updatedAt: '2023-08-11T17:14:26.000Z',
        link: 'https://twism-env-dev.app.link/e/3FBclInlbCb'
    },
    referralReferredState: {},
    theme: {
        name: 'yellow',
        colors: {
            textLighter: '#10222D80',
            textAboveBackground: '#6A4C02',
            secondaryBackground: '#3D3D3D',
            primary: '#FFD705',
            primary200: '#F4A700',
            primary400: '#E0BC6C',
            primary500: '#F7EFCF',
            primary600: '#F7EFCF80',
            secondary: '#F5A901',
            illustration: {
                quinary: '#6A4C02',
                primary: '#B27A01',
                secondary: '#FCCD03',
                tertiary: '#F7E9B9',
                quaternary: '#EEBA00',
                stopColor: '#FCEA9D',
                firstStopColor: '#FCEA9D66',
                secondStopColor: '#FFEDA200'
            },
            text: '#DA9500',
            darkText: '#CDB96A',
            link: '#B27A01',
            linkHover: '#895E00',
            slightBorder: '#F2EFDE',
            slightBackground: '#FFFDFC',
            background: '#C98B01',
            backgroundGradient: 'linear-gradient(263.71deg, #FCCD03 5.13%, #F4A700 96.77%)',
            backgroundGradientHover: 'linear-gradient(263.71deg, #EBB800 5.13%, #E49607 96.77%)',
            backgroundGradient2Hover: 'linear-gradient(263.71deg, #E9B500 5.13%, #C78800 96.77%)',
            slightGradient: 'linear-gradient(180deg, rgba(252, 234, 157, 0.4) 0%, rgba(255, 237, 162, 0) 76.15%)',
            shadowColor: 'rgba(250, 150, 0, 0.42)',
            freeCoinsCampaign: {
                background: '#FFFDF2'
            },
            referral: {
                tracking: {
                    background: 'rgba(253, 251, 242, 0.8)',
                    backgroundItem: 'rgba(224, 188, 108, 0.08)'
                }
            },
            typography: '#474333',
            welcome: {
                backgroundLight: '#FFFCF7',
                backgroundCarousel: '#FFF',
                background: '#653F02',
                colorLight: '#FFC33E',
                dotSlide: '#DBD4C8'
            },
            backgroundCoin: {
                gradientColor1: '#E9B500',
                gradientColor2: '#C78800'
            }
        }
    },
    featureFlags: [
        'dashboard-offer-restriction-field',
        'ops-limit-card-countries',
        'gift-card-graduation',
        'business-coin-setup-remove-reserved-worker',
        'splitted-phone-number-and-country-code',
        'backend-new-menu-start-guide',
        'wix-connect',
        'save-warning-pending-coins',
        'widget-signup-confirmation',
        'business-referral',
        'list-transactions-manager',
        'create-provisional-transaction',
        'custom-color-widget',
        'business-signup',
        'post',
        'ops-buy-coins-rate-limit',
        'ops-biz-payout-stripe-payout-tracker',
        'app-enable-more-than-six-cards-for-gift',
        'woocommerce-connect',
        'app-send-coins-phone-number-required',
        'app-use-settings-page-v2',
        'business-signup-captcha',
        'app-gift-claim-phone-number-required',
        'dashboard-pre-selected-country',
        'app-welcome-backdrop-signin-signup',
        'app-birthday-banner',
        'business-signup-redesign',
        'convert-coins-carousel',
        'new-axxess-onboarding-as-default',
        'widget-cache-api',
        'widget-fast-redemptions',
        'customer-import-v2',
        'shopify-external-activation-email',
        'validate-restricted-emails',
        'shopify-connect',
        'track-events',
        'app-buy-coins',
        'square-connect',
        'app-create-gift-phone-number-required',
        'dashboard-notification-center',
        'app-enable-no-merchants-in-this-map-area',
        'app-offer-qr-code',
        'verify-app-version',
        'app-new-gift-center-navbar',
        'app-signup-start-guide',
        'activation-emails',
        'dashboard-deactivation-feedback',
        'ops-biz-payout-dispatcher',
        'gift-card-fathers-day',
        'app-search-tool',
        'new-use-coins',
        'coins-usage-tips-email',
        'axxess-twism-integration-ios',
        'app-delete-account-link-v2',
        'redeem-first-coin-backdrop',
        'release-flag-app-new-welcome-ui',
        'invite-friends-rewards',
        'expirable-free-coins',
        'link-cards-banner',
        'expirable-coins',
        'check-pending-coins-fidel',
        'app-gift-center-contacts-list',
        'business-default-logo-backend',
        'first-redemption-feedback-actions',
        'use-guard-in-provider-shopify-on-ms',
        'failure-rate-limit',
        'new-signup-widget-wix',
        'new-signup-widget-shopify-modal',
        'messages-all-transactions',
        'app-free-coins-banner',
        'merchant-dashboard-reports',
        'force-popup-provider-login',
        'app-delete-account-link',
        'enable-loyalty-program-term',
        'block-sms-by-country',
        'soft-login-reward-by-email',
        'online-merchant-signup-steps',
        'new-coin-image-page',
        'generate-offline-offer-code-on-twism',
        'add-coins',
        'without-merchant-interface',
        'ops-sell-coins-campaign-status-worker',
        'special-coins-dashboard',
        'customer-acquisition-shopify',
        'use-coins',
        'app-welcome-coins-list-in-wallet',
        'check-pending-coins-bigcommerce',
        'axxess-countdown',
        'customer-acquisition-bigcommerce',
        'add-wix-on-multiple-integration',
        'dashboard-new-business-onboarding',
        'use-smart-redemption-on-square',
        'email-worker',
        'sms-worker',
        'stripe-worker',
        'fidel-worker',
        'push-notification-worker',
        'invite-link',
        'widget-social-rewards',
        'min-credit-card-value-backend',
        'bigcommerce-connect',
        'pending-coins-refund',
        'check-pending-coins-wix',
        'redeem-first-coin',
        'new-card-on-overview-redeemed-coins',
        'app-remove-offers-from-pay-with-coins-flow',
        'new-create-offer-flow',
        'release-flag-widget-new-wallet-ui',
        'widget-provisional-checkout-wix',
        'customer-import-widget',
        'new-manage-loyalty-page',
        'check-pending-coins-shopify',
        'dashboard-new-menu-searchbar',
        'app-signup-phone-number-obrigatory',
        'new-gift-coins',
        'dashboard-identify-backend',
        'app-redeem-coupon',
        'app-wallet-contact-us-modal',
        'check-revoked-reward-providers',
        'app-new-wallet-page',
        'ops-sell-coins-campaign-management',
        'new-segment-for-import',
        'ops-biz-payout-new-purchase-rules',
        'enable-new-password-mail-template',
        'app-restrict-free-coins-to-card-linked-users',
        'app-enable-face-id-authentication',
        'dashboard-segment',
        'gift-template-dynamic',
        'use-smart-redemption',
        'new-consumer-acquired-worker',
        'update-profile-properties-worker',
        'new-refund-page',
        'check-pending-coins-square',
        'customer-acquisition',
        'landing-page-show-cookies-modal',
        'customer-import-shopify',
        'app-send-coins',
        'app-zendesk-help-center',
        'app-complete-profile',
        'merchant-landing-show-header',
        'social-rewards',
        'sell-coins-campaign-flow',
        'customer-acquisition-woocommerce',
        'new-sell-coins-flow',
        'app-wallet-as-initial-after-signup-page',
        'sell-coins-campaign-transaction-flow',
        'offers',
        'new-section-performance-activity-total-spend',
        'create-connect-transaction-history',
        'use-map-solution',
        'ops-biz-payout-trx-tracker',
        'ops-biz-payout-new-purchase-fields',
        'sell-coins-campaign-mail-flow',
        'apply-user-timezone-in-mobile-app',
        'business-coin-setup-captcha',
        'webapp-new-navbar',
        'enable-provider-clover',
        'send-email-first-campaign-incentive',
        'notification-priority-queue',
        'new-widget-settings-page',
        'dashboard-features-onboarding',
        'app-axxess-onboarding',
        'zendesk-business-support',
        'gift-card',
        'new-signup-widget-wix-v2-modal',
        'reports',
        'new-router',
        'business-social-links',
        'twism-wallet-v1',
        'coin-threshold-management',
        'widget-deactivation-notification',
        'use-guard-in-provider-bigcommerce-on-ms',
        'marketing-center',
        'offer-recommendation-group-by-business',
        'customer-acquisition-wix',
        'dashboard-reward-program-event',
        'dashboard-what-is-new',
        'zendesk-support',
        'edit-customer-inactivity',
        'use-reward-purchase-groups',
        'ops-biz-payout-trx-balance-status-updater',
        'offer-free-coins',
        'dashboard-video-education',
        'coins-rules',
        'app-welcome-coins-list-in-pay-with-coins',
        'new-gift-coins-apple-pay-method',
        'for-you-saved-offers',
        'coin-2d-edit-enable',
        'app-new-for-you-page',
        'dashboard-timezone-in-filters',
        'ledger-integration',
        'app-free-coins-wallet-balance-list',
        'logger',
        'app-change-filters-category',
        'app-buy-coins-phone-number-required',
        'app-new-wallet',
        'ops-biz-payout-withdraw',
        'referral-offer',
        'app-offer-qr-code-v2',
        'customer-import-bigcommerce',
        'customer-import',
        'modal-v2-merchant-is-not-selling-coins',
        'npo-coin-image-optional',
        'use-guard-in-provider-square-on-ms',
        'dashboard-new-menu-structure',
        'new-consumer-acquired-worker-retroactive',
        'soft-user',
        'new-onboarding',
        'axxess-twism-integration-android',
        'welcome-business-mail-worker',
        'use-guard-in-provider-woocommerce-on-ms',
        'widget-mobile-wix-resize-window',
        'app-use-v2-gift-center',
        'enable-signin-limit',
        'platform-feedback-any-provider',
        'app-new-gift-center',
        'card-capture',
        'show-merchants-without-offer-on-offers-page',
        'business-referral-widget',
        'business-coin-setup-upload-captcha',
        'dashboard-start-guide',
        'dashboard-import-business-logo',
        'shopify-write-customers-scope',
        'app-new-offers-tab',
        'app-geolocation-in-realtime',
        'app-valentine-campaign',
        'new-config-widget-icon-and-welcome',
        'dashboard-feedback-platform',
        'new-referral-campaign-error-handler',
        'use-terms-v2',
        'expirable-reward-coins',
        'offer-restrictions',
        'connect-transaction-state-machine',
        'app-new-reset-forgot-password',
        'enable-rules-password',
        'redeem-first-coin-dynamic',
        'ops-biz-payout-stripe-balance-status-requester',
        'square-modal',
        'ops-disable-sell-coins-online-biz-without-provider',
        'wallet-dashboard-switch-acount-type',
        'ops-biz-payout-transactions-consolidator',
        'inactive-customer-backend',
        'home-page',
        'app-link-card-phone-number-required',
        'check-pending-coins-woocommerce',
        'ops-biz-payout-stripe-payout-requester',
        'send-warning-pending-coins',
        'check-delayed-pending-coins-transactions',
        'customer-import-woocommerce',
        'stores-you-may-like',
        'ops-add-credit-card-rate-limit',
        'dashboard-new-online-signup',
        'use-guard-in-provider-fidel-on-ms',
        'bypass-wix-dashboard',
        'business-signup-zendesk-widget-support',
        'dashboard-tracking-backend',
        'edit-offer-image',
        'app-clear-all-filters',
        'dashboard-social-rewards',
        'access-3d-coin',
        'responsive-dashboard',
        'app-valentines-day-campaign-copy-active',
        'release-flag-widget-new-welcome-ui'
    ],
    coupons: [],
    customerImportCampaign: {},
    socialReward: [
        {
            id: '40ecc551-c4e8-42e5-9f69-d0af562a9b40',
            createdAt: '2023-07-13T17:59:50.372Z',
            updatedAt: '2023-08-17T13:18:03.000Z',
            coins: 5,
            rewarded: 1,
            status: 'active',
            type: 'facebook-share',
            metadata: {
                url: 'www.facebook.com/fdsfadfds'
            }
        },
        {
            id: 'c7a03836-15dd-4ddd-9d70-acdbe33faecf',
            createdAt: '2023-08-17T13:26:36.250Z',
            updatedAt: '2023-08-17T13:30:14.000Z',
            coins: 150,
            rewarded: 1,
            status: 'active',
            type: 'facebook-like',
            metadata: {
                url: 'https://facebook.com/jonkk'
            }
        },
        {
            id: 'adb50e0c-cd9a-4add-97d6-a79094981649',
            createdAt: '2023-08-17T13:26:46.627Z',
            updatedAt: '2023-08-17T14:08:18.000Z',
            coins: 15,
            rewarded: 1,
            status: 'active',
            type: 'instagram-follow',
            metadata: {
                url: 'https://instagram.com/vitordemboski'
            }
        },
        {
            id: '401bac7d-bd2f-4561-8a0a-35f39da4fada',
            createdAt: '2023-08-17T13:26:54.111Z',
            updatedAt: '2023-08-17T13:26:54.111Z',
            coins: 50,
            rewarded: 0,
            status: 'active',
            type: 'twitter-follow',
            metadata: {
                url: 'https://twitter.com/knmklfvn'
            }
        },
        {
            id: '2aecfc9c-2a7a-47bb-962e-ef5bcc5283d1',
            createdAt: '2023-08-17T13:27:02.350Z',
            updatedAt: '2023-08-17T14:12:54.000Z',
            coins: 15,
            rewarded: 1,
            status: 'active',
            type: 'twitter-share',
            metadata: {
                url: 'www.facebook.com/fdsfadfds'
            }
        },
        {
            id: '6fdd4a36-37e8-450e-bd33-a6676da7c2e6',
            createdAt: '2023-08-17T18:20:46.237Z',
            updatedAt: '2023-08-17T18:20:46.237Z',
            coins: 4,
            rewarded: 0,
            status: 'active',
            type: 'youtube-subscribe',
            metadata: {
                url: 'https://youtube.com/@fadnmjdnf/channels'
            }
        }
    ]
};
export const mockCoupons = [
    {
        id: 'cb3d5b89-e51b-4c4a-92aa-1a294626ac8e',
        createdAt: '2021-12-03T18:58:21.000Z',
        updatedAt: '2021-12-03T18:58:21.000Z',
        provider: 'wix',
        externalId: '6d8e0ee6-6dbe-48b4-8e06-2ea7b9e1e35f',
        code: 'TWM999999',
        status: 'active',
        redeemedAt: null,
        coinsValue: 1000,
        moneyValue: 1000,
        moneyCurrency: 'USD',
        formattedMoneyAmount: '$10.00',
        metadata: {},
        type: 'online'
    },
    {
        id: '9d3b1ed9-13e4-4fc5-9ecd-596694c1c3a2',
        createdAt: '2021-12-03T18:58:31.519Z',
        updatedAt: '2021-12-03T18:58:32.000Z',
        provider: 'wix',
        externalId: 'db0e3f2d-eff4-492b-b5ce-f558ac002def',
        code: 'TWM999999',
        status: 'active',
        redeemedAt: null,
        coinsValue: 1500,
        moneyValue: 1500,
        moneyCurrency: 'USD',
        formattedMoneyAmount: '$15.00',
        metadata: {},
        type: 'online'
    },
    {
        id: '25ad72af-3a40-4c44-b2b8-2517a305dc12',
        createdAt: '2021-12-03T18:58:42.605Z',
        updatedAt: '2021-12-03T18:58:43.000Z',
        provider: 'wix',
        externalId: 'dd0046f5-6eed-4aec-a4cf-d1fe7b289013',
        code: 'TWM999999',
        status: 'active',
        redeemedAt: null,
        coinsValue: 10000,
        moneyValue: 10000,
        moneyCurrency: 'USD',
        formattedMoneyAmount: '$100.00',
        metadata: {},
        type: 'online'
    }
];
export const mockTransactions = {
    items: [
        {
            id: '5ff26915-8b38-4c4e-8e44-7c6239008af1',
            createdAt: '2021-12-03T18:58:42.631Z',
            updatedAt: '2021-12-03T18:58:42.631Z',
            type: 'coupon-create',
            operation: 'decrement',
            formattedMoneyAmount: '$100.00',
            money: '100.00',
            bonus: '0.00',
            coins: '100.00',
            bonusCoins: '0.00',
            metadata: {
                coinExchangeRatio: '1.00',
                coinPurchaseBonus: '0.00',
                coinPurchaseRatio: '6.66',
                couponId: '25ad72af-3a40-4c44-b2b8-2517a305dc12',
                couponCode: 'TWM3KC3YE'
            },
            status: 'success',
            deleted: false,
            pendingCoinsValidAt: null,
            connectTransaction: null,
            message: 'You’ve converted $100.00 coins into an online coupon'
        },
        {
            id: '5e17d2d2-8e5f-4dd3-bc7d-9861ae092ff5',
            createdAt: '2021-12-03T18:58:31.580Z',
            updatedAt: '2021-12-03T18:58:31.580Z',
            type: 'coupon-create',
            operation: 'decrement',
            formattedMoneyAmount: '$15.00',
            money: '15.00',
            bonus: '0.00',
            coins: '15.00',
            bonusCoins: '0.00',
            metadata: {
                coinExchangeRatio: '1.00',
                coinPurchaseBonus: '0.00',
                coinPurchaseRatio: '6.66',
                couponId: '9d3b1ed9-13e4-4fc5-9ecd-596694c1c3a2',
                couponCode: 'TWMLN7R7W'
            },
            status: 'success',
            deleted: false,
            pendingCoinsValidAt: null,
            connectTransaction: null,
            message: 'You’ve converted $15.00 coins into an online coupon'
        },
        {
            id: 'b8286519-fa37-4d46-92cd-e67582d8ec06',
            createdAt: '2021-12-03T18:58:21.035Z',
            updatedAt: '2021-12-03T18:58:21.035Z',
            type: 'coupon-create',
            operation: 'decrement',
            formattedMoneyAmount: '$10.00',
            money: '10.00',
            bonus: '0.00',
            coins: '10.00',
            bonusCoins: '0.00',
            metadata: {
                coinExchangeRatio: '1.00',
                coinPurchaseBonus: '0.00',
                coinPurchaseRatio: '6.66',
                couponId: 'cb3d5b89-e51b-4c4a-92aa-1a294626ac8e',
                couponCode: 'TWMPZ4XGL'
            },
            status: 'success',
            deleted: false,
            pendingCoinsValidAt: null,
            connectTransaction: null,
            message: 'You’ve converted $10.00 coins into an online coupon'
        },
        {
            id: 'd22c3aaf-42bb-4747-98b8-3b266b65a612',
            createdAt: '2021-12-03T18:57:53.479Z',
            updatedAt: '2021-12-03T18:57:53.479Z',
            type: 'business-gift',
            operation: 'increment',
            formattedMoneyAmount: null,
            money: '0.00',
            bonus: '15000.00',
            coins: '0.00',
            bonusCoins: '15000.00',
            metadata: {
                coinExchangeRatio: '1.00',
                coinPurchaseBonus: '0.00',
                coinPurchaseRatio: '6.66',
                requestCoins: 15000,
                requestMoney: 15000,
                awardCoinId: 'e19f86e8-74d4-4130-8ea8-297c86883f2f'
            },
            status: 'success',
            deleted: false,
            pendingCoinsValidAt: null,
            connectTransaction: null,
            message: 'You received 15000 coins as a gift'
        },
        {
            id: '21639bf2-2481-4075-aee8-715ed0c01745',
            createdAt: '2021-12-03T18:56:04.205Z',
            updatedAt: '2021-12-03T18:56:04.205Z',
            type: 'payment-auth',
            operation: 'increment',
            formattedMoneyAmount: '$80.00',
            money: '80.00',
            bonus: '0.00',
            coins: '0.00',
            bonusCoins: '13.33',
            metadata: {
                coinExchangeRatio: '1.00',
                coinPurchaseBonus: '0.00',
                coinPurchaseRatio: '6.66',
                refundsLimitDays: '0',
                availableAt: '2021-12-06T18:56:04.018Z'
            },
            status: 'pending',
            deleted: false,
            pendingCoinsValidAt: '2021-12-06',
            connectTransaction: { status: 'authorized' },
            message: 'You spent $80.00 and will receive 13.33 coins after a payment confirmation'
        }
    ],
    count: 5,
    total: 5,
    links: { next: null }
};
